if (!window.VideoController) {
  window.VideoController = class {
    constructor() {
      this.initializeVideoControls();
    }

    initializeVideoControls() {
      const videoControls = document.querySelectorAll("[data-video-control]");

      videoControls.forEach((button) => {
        const previewCard = button.closest(".madara-preview-card");
        if (!previewCard) return;

        const videoElement = previewCard.querySelector("video-element");
        const playIcon = button.querySelector(".icon-play");
        const pauseIcon = button.querySelector(".icon-pause");

        if (videoElement) {
          button.addEventListener("click", () =>
            this.toggleVideo(videoElement)
          );
          videoElement.addEventListener("play", () =>
            this.updateIcon(playIcon, pauseIcon, true)
          );
          videoElement.addEventListener("pause", () =>
            this.updateIcon(playIcon, pauseIcon, false)
          );
        }
      });
    }

    updateIcon(playIcon, pauseIcon, isPlaying) {
      if (playIcon && pauseIcon) {
        playIcon.style.display = isPlaying ? "none" : "block";
        pauseIcon.style.display = isPlaying ? "block" : "none";
      }
    }

    toggleVideo(videoElement) {
      if (!videoElement) return;

      const playButton = videoElement.querySelector(".media__poster");
      if (playButton) {
        playButton.click();
      }
    }
  };
}

document.addEventListener("DOMContentLoaded", () => {
  new VideoController();
});
